import { HttpWebtrack } from 'utility/http';
import { ConfigActions } from '../../../../utility/http/http-events';
import configureInterceptors from 'utility/http/interceptors/configure-interceptors';
import { store } from '@redux/storeConfig/store';
import { appIntl } from 'utility/context/IntlGlobalProvider';

export const baseUrlVehicleFuel = '/vehicleFuel';
export const baseUrlVehicle = '/vehicle';
export const baseUrlEventActivity = '/eventActivity';
export const baseUrlFuelSensor = '/fuelSensor';
export const baseUrlScheduledReports = '/scheduledReports';
export const baseUrlUnit = '/unit';
export const baseUrlNotification = '/notification';
export const baseUrlUser = '/user';

interface Filters {
  startDate?: string;
  endDate?: string;
  operatorId?: number;
  organizationId?: number;
  divisionId?: number;
  subdivisionId?: number;
  geofenceId?: number;
  eventId?: number;
  unitId?: number;
  groupIds?: string;
  time?: number;
  notificationTypeId?: string;
  notificationId?: number;
  consoleId?: number;
  email?: string;
  comment?: string;
  commentId?: number;
  events?: string;
}

interface FiltersScheduledReports {
  systemJobId?: number;
  systemJobIds?: string;
  reportId?: number;
  scheduleId?: number;
  notificationEmails?: string;
  operatorId?: number;
  organizationId?: number;
  divisionId?: number;
  subdivisionId?: number;
  param1?: string;
  param2?: string;
  param3?: string;
  executeNow?: boolean;
}

interface FiltersNotificationComment {
  notificationId?: number;
  commentId?: number;
  comment?: string;
}

interface FiltersCancelNotification {
  comment?: string;
  notificationList?: string;
  notificationType?: string;
  notifierIdentifier?: string;
  eventId?: number;
  unitId?: number;
  operatorId?: number;
  organizationId?: number;
}

interface FiltersProcessNotification {
  comment?: string;
  notificationList?: string;
  resolutionTypeId?: number;
  unitId?: number;
}

export const getConsolidatedMileageData = (request: Filters, configActions: ConfigActions) => {
  const httpWebtrack = new HttpWebtrack();
  configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);
  httpWebtrack.setConfigMessage({
    object: 'reports.reports',
    action: 'Get',
    genderType: 'PluralMale'
  });

  httpWebtrack.setConfigActions(configActions);
  return httpWebtrack.post(`${baseUrlVehicleFuel}`, request);
};

export const getConsolidatedRunningTimeData = (request: Filters, configActions: ConfigActions) => {
  const httpWebtrack = new HttpWebtrack();
  configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);
  httpWebtrack.setConfigMessage({
    object: 'reports.reports',
    action: 'Get',
    genderType: 'PluralMale'
  });

  httpWebtrack.setConfigActions(configActions);
  return httpWebtrack.post(`${baseUrlVehicleFuel}/consolidatedRunningTime`, request);
};

export const getConsolidatedVehicleActivity = (request: Filters, configActions: ConfigActions) => {
  const httpWebtrack = new HttpWebtrack();
  configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);
  httpWebtrack.setConfigMessage({
    object: 'reports.reports',
    action: 'Get',
    genderType: 'PluralMale'
  });

  httpWebtrack.setConfigActions(configActions);
  return httpWebtrack.post(`${baseUrlVehicle}/GetVehiclesConsActivities`, request);
};

export const getEventActivityDropdown = (request: Filters, configActions: ConfigActions) => {
  const httpWebtrack = new HttpWebtrack();
  configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);
  httpWebtrack.setConfigMessage({
    object: 'reports.reports',
    action: 'Get',
    genderType: 'PluralMale'
  });

  httpWebtrack.setConfigActions(configActions);
  return httpWebtrack.post(`${baseUrlEventActivity}/eventDropdown`, request);
};

export const getTotalEventsActivity = (request: Filters, configActions: ConfigActions) => {
  const httpWebtrack = new HttpWebtrack();
  configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);
  httpWebtrack.setConfigMessage({
    object: 'reports.reports',
    action: 'Get',
    genderType: 'PluralMale'
  });

  httpWebtrack.setConfigActions(configActions);
  return httpWebtrack.post(`${baseUrlEventActivity}/GetTotalEventsActivity`, request);
};

export const getConsolidatedSummary = (request: Filters, configActions: ConfigActions) => {
  const httpWebtrack = new HttpWebtrack();
  configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);
  httpWebtrack.setConfigMessage({
    object: 'reports.reports',
    action: 'Get',
    genderType: 'PluralMale'
  });

  httpWebtrack.setConfigActions(configActions);
  return httpWebtrack.post(`${baseUrlEventActivity}/GetConsolidatedSummary`, request);
};

export const getAllUnitsEventsActivity = (request: Filters, configActions: ConfigActions) => {
  const httpWebtrack = new HttpWebtrack();
  configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);
  httpWebtrack.setConfigMessage({
    object: 'reports.reports',
    action: 'Get',
    genderType: 'PluralMale'
  });

  httpWebtrack.setConfigActions(configActions);
  return httpWebtrack.post(`${baseUrlEventActivity}/GetAllUnitsEventsActivity`, request);
};

export const getUnitEventsActivity = (request: Filters, configActions: ConfigActions) => {
  const httpWebtrack = new HttpWebtrack();
  configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);
  httpWebtrack.setConfigMessage({
    object: 'reports.reports',
    action: 'Get',
    genderType: 'PluralMale'
  });

  httpWebtrack.setConfigActions(configActions);
  return httpWebtrack.post(`${baseUrlEventActivity}/GetUnitEventsActivity`, request);
};

export const getFuelSupplyHistory = (request: Filters, configActions: ConfigActions) => {
  const httpWebtrack = new HttpWebtrack();
  configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);
  httpWebtrack.setConfigMessage({
    object: 'reports.reports',
    action: 'Get',
    genderType: 'PluralMale'
  });

  httpWebtrack.setConfigActions(configActions);
  return httpWebtrack.post(`${baseUrlFuelSensor}`, request);
};

export const getScheduledReportsList = (request: Filters, configActions: ConfigActions) => {
  const httpWebtrack = new HttpWebtrack();
  configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);
  httpWebtrack.setConfigMessage({
    object: 'reports.reports',
    action: 'Get',
    genderType: 'PluralMale'
  });

  httpWebtrack.setConfigActions(configActions);
  return httpWebtrack.post(`${baseUrlScheduledReports}/getScheduledReportsList`, request);
};

export const getAvailableReports = (request: Filters, configActions: {} = {}) => {
  const httpWebtrack = new HttpWebtrack();
  configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);
  httpWebtrack.setConfigMessage({
    object: 'reports.reports',
    action: 'Get',
    genderType: 'PluralMale'
  });

  httpWebtrack.setConfigActions(configActions);
  return httpWebtrack.post(`${baseUrlScheduledReports}/getAvailableReports`, request);
};

export const saveScheduledReport = (
  request: FiltersScheduledReports,
  configActions: ConfigActions
) => {
  const httpWebtrack = new HttpWebtrack();
  configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);
  httpWebtrack.setConfigMessage({
    object: 'reports.reports',
    action: 'Get',
    genderType: 'PluralMale'
  });

  httpWebtrack.setConfigActions(configActions);
  return httpWebtrack.post(`${baseUrlScheduledReports}`, request);
};

export const deleteScheduledReport = (
  request: FiltersScheduledReports,
  configActions: ConfigActions
) => {
  const httpWebtrack = new HttpWebtrack();
  configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);
  httpWebtrack.setConfigMessage({
    object: 'reports.reports',
    action: 'Get',
    genderType: 'PluralMale'
  });

  httpWebtrack.setConfigActions(configActions);
  return httpWebtrack.post(`${baseUrlScheduledReports}/deleteScheduledReports`, request);
};

export const getCommunicationDiagnostics = (request: Filters, configActions: ConfigActions) => {
  const httpWebtrack = new HttpWebtrack();
  configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);
  httpWebtrack.setConfigMessage({
    object: 'reports.reports',
    action: 'Get',
    genderType: 'PluralMale'
  });

  httpWebtrack.setConfigActions(configActions);
  return httpWebtrack.post(`${baseUrlUnit}/GetCommDiagData`, request);
};

export const getNotificationsReport = (request: Filters, configActions: ConfigActions) => {
  const httpWebtrack = new HttpWebtrack();
  configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);
  httpWebtrack.setConfigMessage({
    object: 'reports.reports',
    action: 'Get',
    genderType: 'PluralMale'
  });

  httpWebtrack.setConfigActions(configActions);
  return httpWebtrack.post(`${baseUrlNotification}/GetNotificationsReport`, request);
};

export const getNotificationsReportWithComments = (
  request: Filters,
  configActions: ConfigActions
) => {
  const httpWebtrack = new HttpWebtrack();
  configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);
  httpWebtrack.setConfigMessage({
    object: 'reports.reports',
    action: 'Get',
    genderType: 'PluralMale'
  });

  httpWebtrack.setConfigActions(configActions);
  return httpWebtrack.post(`${baseUrlNotification}/GetNotificationsReportWithComments`, request);
};

export const getNotificationsReportComments = (request: Filters, configActions: ConfigActions) => {
  const httpWebtrack = new HttpWebtrack();
  configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);
  httpWebtrack.setConfigMessage({
    object: 'reports.reports',
    action: 'Get',
    genderType: 'PluralMale'
  });

  httpWebtrack.setConfigActions(configActions);
  return httpWebtrack.post(`${baseUrlNotification}/GetNotificationsReportComments`, request);
};

export const getNotificationsComments = (request: Filters, configActions: ConfigActions) => {
  const httpWebtrack = new HttpWebtrack();
  configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);
  httpWebtrack.setConfigMessage({
    object: 'reports.reports',
    action: 'Get',
    genderType: 'PluralMale'
  });

  httpWebtrack.setConfigActions(configActions);
  return httpWebtrack.post(`${baseUrlNotification}/GetNotificationsComments`, request);
};

export const saveNotificationComment = (
  request: FiltersNotificationComment,
  configActions: ConfigActions
) => {
  const httpWebtrack = new HttpWebtrack();
  configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);
  httpWebtrack.setConfigMessage({
    object: 'reports.reports',
    action: 'Get',
    genderType: 'PluralMale'
  });

  httpWebtrack.setConfigActions(configActions);
  return httpWebtrack.post(`${baseUrlNotification}/PostComment`, request);
};

export const deleteNotificationComment = (
  request: FiltersNotificationComment,
  configActions: ConfigActions
) => {
  const httpWebtrack = new HttpWebtrack();
  configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);
  httpWebtrack.setConfigMessage({
    object: 'reports.reports',
    action: 'Get',
    genderType: 'PluralMale'
  });

  httpWebtrack.setConfigActions(configActions);
  return httpWebtrack.post(`${baseUrlNotification}/DeleteComment`, request);
};

export const cancelNotificationsService = (
  request: FiltersCancelNotification,
  configActions: ConfigActions
) => {
  const httpWebtrack = new HttpWebtrack();
  configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);
  const intl = appIntl();
  httpWebtrack.setConfigMessage({
    object: 'console.notification',
    action: 'Custom',
    customMessage: intl.formatMessage({
      id: 'console.cancelNotificationMessage'
    }),
    customMessageError: intl.formatMessage({
      id: 'console.cancelNotificationErrorMessage'
    })
  });

  httpWebtrack.setConfigActions(configActions);
  return httpWebtrack.post(`${baseUrlNotification}/cancelNotifications`, request);
};

export const processNotificationsService = (
  request: FiltersProcessNotification,
  configActions: ConfigActions
) => {
  const httpWebtrack = new HttpWebtrack();
  configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);
  const intl = appIntl();
  httpWebtrack.setConfigMessage({
    object: 'console.notification',
    action: 'Custom',
    customMessage: intl.formatMessage({
      id: 'console.processNotificationMessage'
    }),
    customMessageError: intl.formatMessage({
      id: 'console.processNotificationErrorMessage'
    })
  });

  httpWebtrack.setConfigActions(configActions);
  return httpWebtrack.post(`${baseUrlNotification}/processNotifications`, request);
};

export interface RequestAPIRequestReport {
  startDate: string;
  endDate: string;
  operatorId: number;
  organizationId: number;
}
export function getApiRequestReportData<T>(
  request: Partial<RequestAPIRequestReport>,
  configActions: ConfigActions
) {
  const httpWebtrack = new HttpWebtrack();
  configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);
  httpWebtrack.setConfigActions(configActions);
  const data: Promise<T> = httpWebtrack.post(`${baseUrlUnit}/ApiRequestReport`, request);
  return data;
}

export interface ResquestUserHistory {
  startDate: string;
  endDate: string;
  userName: string;
}
export function getUserHistoryService<T>(
  request: ResquestUserHistory,
  configActions: ConfigActions
) {
  const httpWebtrack = new HttpWebtrack();
  configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);
  httpWebtrack.setConfigActions(configActions);
  const data: Promise<T> = httpWebtrack.post(`${baseUrlUser}/getHistory`, request);
  return data;
}
